<template>
    <b-modal
        no-fade
        ref="dialog"
        title-tag="h2"
        title="Save As Template"
        lazy
        no-close-on-backdrop
        no-close-on-esc
    >
        <p>
            Create a purchase order template based on the details of this
            purchase order. Supplier and items information will be brought into
            the template automatically.
        </p>

        <b-form-group label-cols="3" label="Template Title:" label-for="title">
            <b-form-input
                ref="title-input"
                :disabled="isSaving"
                v-model="title"
                placeholder="Template Title (required)"
                v-validate="'required'"
                name="title"
                :class="{
                    'border-danger': errors.has('title')
                }"
            />
        </b-form-group>

        <b-form-group
            label-cols="3"
            label="Description:"
            label-for="description"
        >
            <b-textarea
                :disabled="isSaving"
                v-model="description"
                placeholder="Template Description (optional)"
                name="description"
            />
        </b-form-group>

        <template v-slot:modal-footer="{ cancel }">
            <loader v-if="isSaving" :margin="1" />

            <b-button
                class="mr-auto"
                variant="secondary"
                @click="cancel"
                v-if="!isSaving"
            >
                Cancel
            </b-button>

            <b-button v-if="!isSaving" variant="primary" @click="submit">
                Submit
            </b-button>
        </template>
    </b-modal>
</template>

<script>
import Loader from "@/module/commons/loader";

export default {
    components: {
        Loader
    },
    data() {
        return {
            orderId: null,
            isSaving: false,
            title: "",
            description: "",
            sourceCatalog: null,
            supplierId: null,
            elements: []
        };
    },
    methods: {
        open(params) {
            this.title = params.title || "";
            this.description = params.description || "";
            this.sourceCatalog = params.sourceCatalog || null;
            this.supplierId = params.supplierId || null;
            this.elements = params.elements || [];
            this.$refs.dialog.show();

            setTimeout(() => {
                this.$refs["title-input"].$el.focus();
            }, 300);
        },
        async submit() {
            try {
                this.isSaving = true;

                let sourceCatalog = this.sourceCatalog;
                if (sourceCatalog === "null") {
                    sourceCatalog = null;
                }

                let data = {
                    name: this.title,
                    description: this.description,
                    source_catalog: sourceCatalog,
                    supplier_id: this.supplierId,
                    elements: this.elements
                };

                let res = await this.$http.post(
                    `${process.env.BARRAMUNDI}inventory/template/save`,
                    data
                );

                if (
                    res.data.response &&
                    res.data.response.resources &&
                    res.data.response.resources.encoded_id
                ) {
                    this._message("Template created.");
                    this.$refs.dialog.hide();
                } else {
                    throw new Error("Error creating template.");
                }
            } catch (err) {
                this.isSaving = false;
                this._message(err.message, "danger");
            }
        }
    }
};
</script>
